import React from "react";
import ParlayRenderer from "../../components/ParlayRenderer/ParlayRenderer";
import PreSelectedParlayBanner from "../../components/Banners/PreSelectedParlayBanner/PreSelectedParlayBanner";
import useDeviceType from "../../hooks/useDeviceType";
import usePicksViewModel from "./usePicksViewModel";

import "./PicksView.style.scss";
const PicksView = ({})=>{

    const vm = usePicksViewModel();
    const {isDesktop} = useDeviceType();
    if(!vm.preSelectedParlay)
        return null;

    return (
        <div className={"PicksView"}>
            {isDesktop ? <PicksViewDesktop vm={vm}/> :
                         <PicksViewMobile vm={vm}/>}
        </div>
    );
}

const PicksViewDesktop = ({vm})=>{
    return <div className="PicksViewDesktop" >
                <PreSelectedParlayBanner preSelectedParlay={vm.preSelectedParlay} />
           </div>
};
const PicksViewMobile = ({vm})=>{
    return <div className="PicksViewMobile">
        {<ParlayRenderer parlay={vm.userParlay}
                         prizeAsset={vm.prizeAsset}/>}
    </div>
};

export default PicksView;